export enum ModalProgressDirection {
  Next = 'Next',
  Save = 'Save',
}
